'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = require('draft-js');

require('./styles.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findLinkEntities(contentBlock, callback) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return entityKey !== null && _draftJs.Entity.get(entityKey).getType() === 'LINK';
    }, callback);
}

var Link = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(Link, _PureComponent);

    function Link() {
        (0, _classCallCheck3.default)(this, Link);
        return (0, _possibleConstructorReturn3.default)(this, (Link.__proto__ || (0, _getPrototypeOf2.default)(Link)).apply(this, arguments));
    }

    (0, _createClass3.default)(Link, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                entityKey = _props.entityKey;

            var _Entity$get$getData = _draftJs.Entity.get(entityKey).getData(),
                url = _Entity$get$getData.url;

            return _react2.default.createElement(
                'span',
                { className: 'rde-link-decorator' },
                _react2.default.createElement(
                    'a',
                    { href: url, title: url },
                    children
                )
            );
        }
    }]);
    return Link;
}(_react.PureComponent), _class.propTypes = {
    entityKey: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.array
}, _temp);
exports.default = {
    strategy: findLinkEntities,
    component: Link
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/decorators/Link/index.js
// module id = 126
// module chunks = 0